import React from 'react';
import {SdfSelectSimple} from '@synerg/react-components';
import {Controller} from 'react-hook-form';
import {SdfAlert} from '@synerg/react-components';
import {get} from 'lodash';
import {SdfButton} from '@synerg/react-components';

export default function StepFour({control, advisors, error, setRetry}){
	const businessList = get(advisors,'business',[]).map(elem => { return { label: elem.fullName, value: elem._id};})
	const technicalList = get(advisors,'technical',[]).map(elem => { return { label: elem.fullName, value: elem._id};});
	const partnerList = get(advisors,'partner',[]).map(elem => { return { label: elem.fullName, value: elem._id};})

	return (
		<div className='mb-56'>
			{error && <div>
				<SdfAlert className='mb-2' type="banner" status="error" size="sm" icon="alert-error">
					Error occurred while trying to retrieve advisors
					<span slot="action">
						<SdfButton
								onClick={() => setRetry(prev => prev + 1)}
								empahsis="primary">
							Try Again
						</SdfButton>
					</span>
				</SdfAlert>
			</div>}
			<div className="text-heading-05 font-bold mb-10 mt-12">Add ADP advisors </div>

			<section className='form3'>
				<div>
					<Controller
								name='businessDevelopmentAdvisor'
								control={control}
								rules={{
									required: false
								}}
								render={ ({field: {value, onChange}, fieldState: {error}}) => (
										<SdfSelectSimple
												placeholder='Select one...'
												label='Business development advisor'
												name='businessDevelopmentAdvisor'
												className='w-1/2 mb-6'
												state={'normal'}
												onSdfChange={(e) =>{onChange(e.detail)}}
												items={businessList}
												filterable={true}
												value={ value || undefined}
										/>)}
						/>
					</div>

					<div>
					<Controller
							name='technicalAdvisor'
							control={control}
							rules={{
								required: false
							}}
							render={ ({field: {value, onChange}, fieldState: {error}}) => (
									<SdfSelectSimple
											placeholder='Select one...'
											label='Technical advisor'
											name='technicalAdvisor'
											className='w-1/2 mb-6'
											state='normal'
											onSdfChange={(e) => {onChange(e.detail)}}
											items={technicalList}
											filterable={true}
											value={value || undefined}
									/>)}
					/>
					</div>

					<div>
						<Controller
								name='partnerDevelopmentAdvisor'
								control={control}
								rules={{
									required: false
								}}
								render={ ({field: {value, onChange}, fieldState: {error}}) => (
										<SdfSelectSimple
												placeholder='Select one...'
												label='Partner development advisor'
												name='partnerDevelopmentAdvisor'
												className='w-1/2 mb-6'
												state='normal'
												onSdfChange={(e) => {onChange(e.detail)}}
												items={partnerList}
												filterable={true}
												value={value || undefined}
										/>)}
						/>
					</div>

			</section>


		</div>
	);
}
